import React, { useEffect, useLayoutEffect, useState } from "react";
import Cookies from "js-cookie";
import "./darkModeButton.css";

function DarkModeButton() {
  const [isDarkMode, setIsDarkMode] = useState(false);


  useLayoutEffect(()=>{
    const cookie = Cookies.get('site-theme');
    if (cookie) {
      setIsDarkMode(cookie === "dark" ? true: false)
      document.documentElement.setAttribute("data-theme", cookie );
    }else {
      setIsDarkMode(false)
      Cookies.set("site-theme", 'light' )
    }
  
  },[])
  function handleClick(){
    // first read to see if there is a cookie, 
    // if no cookie, set cookie to default theme
    // if there is cookie ,set theme 
    setIsDarkMode(!isDarkMode);
    console.log(isDarkMode ? "dark" : 'light')
    Cookies.set("site-theme", isDarkMode ? "light" : 'dark' )
    document.documentElement.setAttribute("data-theme", isDarkMode ? "light" : 'dark' );
   
  }
  return (
    <>
      {!isDarkMode ? (
        <svg
          className="moon"
          onClick={() => {
            handleClick();
          }}
          xmlns="http://www.w3.org/2000/svg"
          fill="#FFFFFF"
          width="800px"
          height="800px"
          viewBox="0 0 56 56"
        >
          <path d="M 38.5235 11.1250 L 33.1797 11.1250 L 33.1797 11.0078 L 38.6407 3.8125 C 39.1329 3.1795 39.3204 2.7811 39.3204 2.3592 C 39.3204 1.6329 38.7578 1.1875 37.9844 1.1875 L 30.4610 1.1875 C 29.7578 1.1875 29.2188 1.6565 29.2188 2.3827 C 29.2188 3.1565 29.7578 3.6016 30.4610 3.6016 L 35.5000 3.6016 L 35.5000 3.7187 L 29.9688 10.8906 C 29.4766 11.5469 29.2891 11.8750 29.2891 12.3672 C 29.2891 13.0469 29.8282 13.5625 30.6016 13.5625 L 38.5235 13.5625 C 39.2266 13.5625 39.7422 13.0938 39.7422 12.3203 C 39.7422 11.6172 39.2266 11.1250 38.5235 11.1250 Z M 49.4924 20.1016 L 45.7188 20.1016 L 45.7188 20.0078 L 49.6095 14.9219 C 50.0545 14.3125 50.2422 13.9609 50.2422 13.5391 C 50.2422 12.8594 49.7031 12.4141 48.9766 12.4141 L 43.2344 12.4141 C 42.5782 12.4141 42.0860 12.8828 42.0860 13.5625 C 42.0860 14.2891 42.5782 14.7344 43.2344 14.7344 L 46.6329 14.7344 L 46.6329 14.8281 L 42.7657 19.8906 C 42.3204 20.4531 42.1563 20.8281 42.1563 21.2969 C 42.1563 21.9297 42.6485 22.4219 43.3751 22.4219 L 49.4924 22.4219 C 50.1721 22.4219 50.6406 21.9765 50.6406 21.2500 C 50.6406 20.5703 50.1721 20.1016 49.4924 20.1016 Z M 25.8438 54.8125 C 34.4219 54.8125 41.3594 50.5000 44.5235 43.1641 C 44.9453 42.1562 44.8047 41.3828 44.3594 40.9141 C 43.9375 40.5156 43.2344 40.4219 42.3907 40.7500 C 40.6329 41.4531 38.4766 41.8516 35.7813 41.8516 C 25.3047 41.8516 18.5547 35.3125 18.5547 25.0234 C 18.5547 22.1875 19.0938 19.3750 19.8204 17.8984 C 20.2891 16.9609 20.2422 16.1641 19.8438 15.6719 C 19.3985 15.1562 18.6016 14.9922 17.5000 15.4375 C 10.3047 18.3672 5.3594 25.8672 5.3594 34.6328 C 5.3594 46.0469 13.7500 54.8125 25.8438 54.8125 Z M 25.8907 51.2500 C 15.8829 51.2500 8.9219 43.9609 8.9219 34.3516 C 8.9219 28.4453 11.6641 23.2422 16.0235 19.9141 C 15.4610 21.4375 15.1329 23.7812 15.1329 26.0312 C 15.1329 37.5625 23.1016 45.2969 34.8907 45.2969 C 37.0000 45.2969 38.9219 45.0391 39.9063 44.6875 C 36.9766 48.7422 31.7500 51.2500 25.8907 51.2500 Z M 39.1563 28.1172 L 35.9453 28.1172 L 35.9453 28.0234 L 39.2500 23.6406 C 39.6719 23.0312 39.8594 22.7265 39.8594 22.3281 C 39.8594 21.6484 39.3438 21.2500 38.6641 21.2500 L 33.6016 21.2500 C 32.9688 21.2500 32.5000 21.6953 32.5000 22.3516 C 32.5000 23.0312 32.9688 23.4531 33.6016 23.4531 L 36.4141 23.4531 L 36.4141 23.5469 L 33.1563 27.9062 C 32.7344 28.4687 32.5704 28.7969 32.5704 29.2422 C 32.5704 29.8516 33.0391 30.2969 33.7188 30.2969 L 39.1563 30.2969 C 39.7891 30.2969 40.2344 29.8750 40.2344 29.1953 C 40.2344 28.5391 39.7891 28.1172 39.1563 28.1172 Z" />
        </svg>
      ) : (
        <svg
          className="sun"
          onClick={() => {
            handleClick();
          }}
          xmlns="http://www.w3.org/2000/svg"
          fill="#ffa620"
          height="800px"
          width="800px"
          version="1.1"
          id="Capa_1"
          viewBox="0 0 207.628 207.628"
        >
          <circle cx="103.814" cy="103.814" r="45.868" />
          <path d="M103.814,157.183c-29.427,0-53.368-23.941-53.368-53.368s23.941-53.368,53.368-53.368s53.368,23.941,53.368,53.368  S133.241,157.183,103.814,157.183z M103.814,65.446c-21.156,0-38.368,17.212-38.368,38.368s17.212,38.368,38.368,38.368  s38.368-17.212,38.368-38.368S124.97,65.446,103.814,65.446z" />
          <path d="M103.814,39.385c-4.142,0-7.5-3.358-7.5-7.5V7.5c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v24.385  C111.314,36.027,107.956,39.385,103.814,39.385z" />
          <path d="M103.814,207.628c-4.142,0-7.5-3.358-7.5-7.5v-24.385c0-4.142,3.358-7.5,7.5-7.5s7.5,3.358,7.5,7.5v24.385  C111.314,204.271,107.956,207.628,103.814,207.628z" />
          <path d="M200.128,111.314h-24.385c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h24.385c4.142,0,7.5,3.358,7.5,7.5  S204.271,111.314,200.128,111.314z" />
          <path d="M31.885,111.314H7.5c-4.142,0-7.5-3.358-7.5-7.5s3.358-7.5,7.5-7.5h24.385c4.142,0,7.5,3.358,7.5,7.5  S36.027,111.314,31.885,111.314z" />
          <path d="M154.676,60.452c-1.919,0-3.839-0.732-5.303-2.197c-2.929-2.929-2.929-7.678,0-10.606l17.243-17.242  c2.929-2.929,7.678-2.93,10.606,0c2.929,2.929,2.929,7.678,0,10.606l-17.243,17.242C158.515,59.72,156.595,60.452,154.676,60.452z" />
          <path d="M35.709,179.419c-1.919,0-3.839-0.732-5.303-2.197c-2.929-2.929-2.929-7.678,0-10.606l17.243-17.243  c2.929-2.929,7.678-2.929,10.606,0c2.929,2.929,2.929,7.678,0,10.606l-17.243,17.243C39.548,178.687,37.629,179.419,35.709,179.419z  " />
          <path d="M171.918,179.419c-1.919,0-3.839-0.732-5.303-2.197l-17.243-17.243c-2.929-2.929-2.929-7.678,0-10.606  c2.929-2.929,7.678-2.929,10.606,0l17.243,17.243c2.929,2.929,2.929,7.678,0,10.606  C175.757,178.687,173.838,179.419,171.918,179.419z" />
          <path d="M52.952,60.452c-1.919,0-3.839-0.732-5.303-2.197L30.406,41.013c-2.929-2.929-2.929-7.677,0-10.606  c2.929-2.929,7.678-2.93,10.606,0l17.243,17.242c2.929,2.929,2.929,7.677,0,10.606C56.791,59.72,54.872,60.452,52.952,60.452z" />
        </svg>
      )}
    </>
  );
}

export default DarkModeButton;
